import { Grid } from "@mui/material";
import { SiteInformation } from "react-common-ui-library";
import { useSelector } from "react-redux";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { StyledProviderReviewInfoGridResponsive } from "../../../Styles/AccountCreation/ProviderAndCertifierAccountCreation/ProviderReviewInfoStyles";
import ProviderReviewInfo from "./ProviderReviewInfo";
import { transformProviderSiteList } from "../../../Services/CommonServices";

/**
 * @description Provider Review Info Parent component that wraps the site information and ProviderReviewInfo component.
 * @returns {ReactNode} React component consisting of Site information and Review Info component.
 */
const ProviderReviewInfoWrapper = () => {
  const { siteDetails } = useSelector((state) =>
    manageProviderAccountCreationSelector(state)
  );

  return (
    <Grid container columnSpacing={7}>
      <Grid item xs={12} md={4}>
        <SiteInformation
          siteLocationList={transformProviderSiteList(siteDetails)}
        />
      </Grid>
      <StyledProviderReviewInfoGridResponsive item xs={12} md={8}>
        <ProviderReviewInfo />
      </StyledProviderReviewInfoGridResponsive>
    </Grid>
  );
};

export default ProviderReviewInfoWrapper;
